export const GET_SUBSCRIPTION_RULES = 'GET_SUBSCRIPTION_RULES';
export const GET_SUBSCRIPTION_RULE_BY_ID = 'GET_SUBSCRIPTION_RULE_BY_ID';
export const UPDATE_SUBSCRIPTION_RULE = 'UPDATE_SUBSCRIPTION_RULE';
export const DELETE_SUBSCRIPTION_RULE = 'DELETE_SUBSCRIPTION_RULE';
export const CREATE_SUBSCRIPTION_RULE = 'CREATE_SUBSCRIPTION_RULE';
